// インドの森: A11y修正パッチ（2026-04-28）
// 軽微なアクセシビリティ問題4件を実行時補正
(function () {
  function fixHeroImage() {
    document.querySelectorAll('.image-with-text__media img').forEach(function (img) {
      if (img.alt && img.alt.trim()) return;
      var section = img.closest('.shopify-section');
      var id = section ? section.id : '';
      if (id.indexOf('kunna_lineup_intro') !== -1) {
        img.alt = 'クンナ・ダッシュさん監修の商品ラインナップ';
      } else if (id.indexOf('kunna_curry_preview') !== -1) {
        img.alt = 'サンタナ 本格インドカレー（レトルト）パッケージ見本';
      } else if (id.indexOf('image-with-text') !== -1) {
        img.alt = 'コナーラク・スーリヤ寺院（インド・オリッサ州、世界遺産）';
      } else {
        // その他のセクションは近くの見出しテキストから補完
        var heading = section && section.querySelector('h1, h2, .image-with-text__heading');
        img.alt = heading ? heading.textContent.trim() : 'インドの森 セクション画像';
      }
    });
  }

  function fixIframeTitles() {
    document.querySelectorAll('iframe:not([title])').forEach(function (f) {
      var src = f.src || '';
      f.setAttribute('title', src.indexOf('poing') !== -1 ? '商品レビュー・お知らせウィジェット' : '埋め込みコンテンツ');
    });
  }

  function fixPoingPongButton() {
    document.querySelectorAll('.poingpong2__floating, button.poingpong2__floating, [class*="poingpong"][class*="floating"]').forEach(function (el) {
      if (!el.getAttribute('aria-label')) {
        el.setAttribute('aria-label', 'レビュー・お知らせを開く');
      }
      var img = el.querySelector('img');
      if (img && (!img.alt || !img.alt.trim())) {
        img.alt = '';  // Decorative since button has aria-label
        img.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function fixCartItemLinks() {
    document.querySelectorAll('.cart-item__link').forEach(function (a) {
      if (a.getAttribute('aria-label')) return;
      // Find the product title in the same cart item row
      var item = a.closest('.cart-item, tr, li, .cart-drawer__item') || a.parentElement;
      var titleEl = item && item.querySelector('.cart-item__name, .cart-item__title, a[href*="/products/"]:not(.cart-item__link), .h4');
      var title = titleEl ? titleEl.textContent.trim() : '';
      if (!title) {
        // Fallback: extract product handle from href
        var m = a.href.match(/\/products\/([^?#]+)/);
        title = m ? m[1].replace(/-/g, ' ') : '商品';
      }
      a.setAttribute('aria-label', title + 'の商品ページを開く');
    });
  }

  function applyAll() {
    fixHeroImage();
    fixPoingPongButton();
    fixCartItemLinks();
    fixIframeTitles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }

  // Re-apply after dynamic insertions (cart drawer updates, app loads)
  var observer = new MutationObserver(function () {
    applyAll();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
